module.exports = __webpack_public_path__ + "img/img18.2eaf0632.svg";